export const getFirebaseErrorMessage = (errorCode: string): string => {
  switch (errorCode) {
    case 'auth/email-already-in-use':
      return 'Ten adres e-mail jest już zajęty.';
    case 'auth/user-not-found':
      return 'Nie znaleziono konta z tym adresem e-mail.';
    case 'auth/wrong-password':
      return 'Nieprawidłowe hasło.';
    case 'auth/invalid-email':
      return 'Niepoprawny adres e-mail.';
    case 'auth/too-many-requests':
      return 'Link można wysłać ponownie tylko raz na 30 sekund. Spróbuj później.';
    case 'auth/weak-password':
      return 'Hasło jest zbyt słabe.';
    case 'auth/invalid-credential':
      return 'Nieprawidłowe dane logowania.';
    case 'auth/popup-closed-by-user':
      return 'Zamknąłeś okno logowania przed zakończeniem.';
    case 'auth/account-exists-with-different-credential':
      return 'Konto z tym adresem e-mail już istnieje. Użyj innej metody logowania.';
    case 'auth/cancelled-popup-request':
      return 'Anulowano logowanie przez Google.';
    default:
      return 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.';
  }
};
